// extracted by mini-css-extract-plugin
module.exports = {"sortableItem":"style_sortableItem__3n9cn","name":"style_name__2zG9O"};